/* ==========================================================================
   Cura — Collection Grid
   1. Card re-init after Dawn's facet AJAX re-renders
   2. Infinite scroll / Load More pagination
   ========================================================================== */
(function () {
  'use strict';

  function watchFacets(root) {
    if (root.dataset.ccgWatch === 'true') return;
    root.dataset.ccgWatch = 'true';

    var container = root.querySelector('#ProductGridContainer');
    if (!container) return;

    var scheduled = null;
    var observer = new MutationObserver(function () {
      if (scheduled) clearTimeout(scheduled);
      scheduled = setTimeout(function () {
        if (typeof window.curaFCInitCards === 'function') {
          window.curaFCInitCards(container);
        }
        setupInfinite(root);
      }, 60);
    });

    observer.observe(container, { childList: true, subtree: true });
  }

  function setupInfinite(root) {
    var wrapper = root.querySelector('[data-cg-infinite]');
    if (!wrapper) return;
    if (wrapper.dataset.cgBound === 'true') return;
    wrapper.dataset.cgBound = 'true';

    var nextUrl = wrapper.dataset.nextUrl;
    var type = wrapper.dataset.paginationType;
    var spinner = wrapper.querySelector('[data-cg-spinner]');
    var loadMoreBtn = wrapper.querySelector('[data-cg-load-more]');
    var grid = root.querySelector('#product-grid');
    var loading = false;

    if (!nextUrl || !grid) return;

    function fetchPage() {
      if (loading || !nextUrl) return;
      loading = true;

      if (spinner) spinner.hidden = false;
      if (loadMoreBtn) loadMoreBtn.disabled = true;

      fetch(nextUrl)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('#product-grid');
          if (newGrid) {
            newGrid.querySelectorAll('.cura-cg__item').forEach(function (item) {
              grid.appendChild(item);
            });
            if (typeof window.curaFCInitCards === 'function') {
              window.curaFCInitCards(grid);
            }
          }

          var newWrapper = doc.querySelector('[data-cg-infinite]');
          if (newWrapper && newWrapper.dataset.nextUrl) {
            nextUrl = newWrapper.dataset.nextUrl;
            wrapper.dataset.nextUrl = nextUrl;
            if (loadMoreBtn) loadMoreBtn.disabled = false;
          } else {
            nextUrl = null;
            if (ioObserver) ioObserver.disconnect();
            wrapper.remove();
            return;
          }
        })
        .catch(function (err) {
          console.error('Cura infinite scroll error:', err);
          if (loadMoreBtn) loadMoreBtn.disabled = false;
        })
        .finally(function () {
          loading = false;
          if (spinner) spinner.hidden = true;
        });
    }

    var ioObserver = null;

    if (type === 'infinite') {
      if ('IntersectionObserver' in window) {
        ioObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && !loading && nextUrl) {
              fetchPage();
            }
          });
        }, { rootMargin: '0px 0px 400px 0px' });
        ioObserver.observe(wrapper);
      } else {
        var fallbackBtn = document.createElement('button');
        fallbackBtn.type = 'button';
        fallbackBtn.className = 'cura-cg__load-more';
        fallbackBtn.textContent = 'Load more';
        wrapper.insertBefore(fallbackBtn, spinner);
        loadMoreBtn = fallbackBtn;
        type = 'load_more';
      }
    }

    if (type === 'load_more' && loadMoreBtn) {
      loadMoreBtn.addEventListener('click', fetchPage);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-cura-collection-grid]').forEach(function (root) {
      watchFacets(root);
      setupInfinite(root);
      if (typeof window.curaFCInitCards === 'function') {
        window.curaFCInitCards(document);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-cura-collection-grid]');
    if (root) {
      root.dataset.ccgWatch = 'false';
      var wrapper = root.querySelector('[data-cg-infinite]');
      if (wrapper) wrapper.dataset.cgBound = 'false';
      watchFacets(root);
      setupInfinite(root);
    }
  });
})();